var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 12.8929C8.90237 13.2834 8.90237 13.9166 9.29289 14.3071C9.68342 14.6976 10.3166 14.6976 10.7071 14.3071L9.29289 12.8929ZM13.6 10L14.3071 10.7071C14.6976 10.3166 14.6976 9.68342 14.3071 9.29289L13.6 10ZM10.7071 5.69289C10.3166 5.30237 9.68342 5.30237 9.29289 5.69289C8.90237 6.08342 8.90237 6.71658 9.29289 7.10711L10.7071 5.69289ZM6.4 9C5.84771 9 5.4 9.44771 5.4 10C5.4 10.5523 5.84771 11 6.4 11V9ZM18 10C18 14.4183 14.4183 18 10 18V20C15.5228 20 20 15.5228 20 10H18ZM10 18C5.58172 18 2 14.4183 2 10H0C0 15.5228 4.47715 20 10 20V18ZM2 10C2 5.58172 5.58172 2 10 2V0C4.47715 0 0 4.47715 0 10H2ZM10 2C14.4183 2 18 5.58172 18 10H20C20 4.47715 15.5228 0 10 0V2ZM10.7071 14.3071L14.3071 10.7071L12.8929 9.29289L9.29289 12.8929L10.7071 14.3071ZM14.3071 9.29289L10.7071 5.69289L9.29289 7.10711L12.8929 10.7071L14.3071 9.29289ZM6.4 11H13.6V9H6.4V11Z",
    fill: "#5268AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightCircle);
export default __webpack_public_path__ + "static/media/icon-Arrow-right-circle.17539d553d358833b6734fdaa613047a.svg";
export { ForwardRef as ReactComponent };